module.exports = __webpack_public_path__ + "img/brightness-high-fill.cb319a11.svg";